import React from 'react'

import Star from '@maestro/commerce-blocks/components/reviews/star'

export default function StarsSkeleton() {
  return (
    <div className="review-summary">
      <div className="review-stars">
        {Array.from({ length: 5 }).map((_, index) => (
          <Star key={`review-star-${index}`} fillType="star-empty" />
        ))}
      </div>
    </div>
  )
}
